import styled from 'styled-components';
import {
    DropdownButton as ConstellationDropdownButton,
    MenuItem as ConstellationMenuItem
} from '@zillow/constellation';

export const Container = styled.div`
    max-width: 381px;
    margin-bottom: 16px;
`;

export const MenuItem = styled(ConstellationMenuItem)<{ isSelected?: boolean }>`
    ${(props) => (props.isSelected ? 'background-color: #F2FAFF;' : '')}
    color: #2a2a33;
    font-weight: 400;
`;

export const DropdownButton = styled(ConstellationDropdownButton)`
    height: 36px;
`;
